/**
 * Machine processing log (pilot): labels and the CSV of the Processing runs page. PURE.
 */
import { gramsToKgString } from '../api/mappers'
import type { MachineIdentifiedBy, ProcessRunRow } from '../api/processRuns'

export const IDENTIFIED_LABEL: Record<MachineIdentifiedBy, string> = {
  QR_SCAN: 'Label scanned',
  LIST: 'Picked from list',
}

/** How the machine was named at open; runs before the machine-label scan show "—". */
export const identifiedLabel = (v: MachineIdentifiedBy | null) => (v ? IDENTIFIED_LABEL[v] : '—')

const kg = (g: number | null) => (g === null ? '' : gramsToKgString(g))

export const PROCESS_RUNS_CSV_HEADER = [
  'Run',
  'Machine code',
  'Machine',
  'Step',
  'Crop',
  'Status',
  'Stream',
  'Operator',
  'Cleanout by',
  'Opened at',
  'Closed at',
  'Machine identified by',
  'Machine label',
  'Input kg',
  'Flush kg',
  'Product kg',
  'By-product kg',
  'Reject kg',
  'Output kg',
  'Residual %',
  'Lots in',
  'Farmers',
  'Batches out',
  'Open exceptions',
]

export function processRunsCsvRows(rows: readonly ProcessRunRow[]): string[][] {
  return rows.map((r) => [
    r.code,
    r.equipmentCode ?? '',
    r.equipmentName ?? '',
    r.stepCode,
    r.cropName ?? '',
    r.status,
    r.stream ?? '',
    r.operator?.name ?? '',
    r.cleanoutBy?.name ?? '',
    r.openedAt ?? '',
    r.closedAt ?? '',
    r.identifiedBy ?? '',
    r.machineLabel ?? '',
    kg(r.inputG),
    kg(r.flushG),
    kg(r.productG),
    kg(r.byproductG),
    kg(r.rejectG),
    kg(r.outputG),
    r.residualPct ?? '',
    r.lotsIn.map((l) => l.code).join(' '),
    [...new Set(r.lotsIn.map((l) => l.farmerCode).filter(Boolean))].join(' '),
    r.batchesOut.map((b) => b.code).join(' '),
    String(r.openExceptions),
  ])
}
